var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRippleRings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#880088",
    width: 1600,
    height: 1000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#606",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-width",
    dur: "13s",
    repeatCount: 10,
    values: "0;200;0;0",
    keySplines: ".5 0 .5 1;.5 0 .5 1;.5 0 .5 1",
    calcMode: "spline"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 500,
    r: 1,
    fill: "#606",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    dur: "5s",
    repeatCount: 100,
    values: "0;100;0;0",
    keySplines: ".5 0 .5 1;.5 0 .5 1;.5 0 .5 1",
    calcMode: "spline"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 500,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 500,
    r: 110
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 500,
    r: 180
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 500,
    r: 260
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 500,
    r: 350
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 500,
    r: 450
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 500,
    r: 560
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 500,
    r: 680
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 500,
    r: 810
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 500,
    r: 950
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRippleRings);
export default __webpack_public_path__ + "static/media/ripple-rings.141bb2fd3a617733b1e45c2c90c6ea7b.svg";
export { ForwardRef as ReactComponent };